import React from 'react';
import PropTypes from 'prop-types';
import './pulsing.scss';

class Pulsing extends React.Component {
    constructor(props) {
        super();
        this.componentTimeout = null;
        this.pulseAfterArray = props.pulseAfter.reverse();
        this.state = {
            animate: false
        };
    }

    componentDidMount() {
        this.delayPulsing();
    }

    componentWillUnmount() {
        clearTimeout(this.componentTimeout);
    }

    delayPulsing() {
        if (this.pulseAfterArray.length === 0) {
            return;
        }
        const pulseAfter = this.pulseAfterArray.pop();
        if (pulseAfter < 0) {
            return;
        }
        this.componentTimeout = setTimeout(() => this.startAnimation(), pulseAfter * 1000);
    }

    startAnimation() {
        this.componentTimeout = setTimeout(() => this.stopAnimation(), 9 * 1000);
        this.setState({
            animate: true
        });
    }

    stopAnimation() {
        this.setState({
            animate: false
        });

        this.delayPulsing();
    }

    render() {
        return (
            <div className={`pulsing ${this.state.animate ? 'animate' : ''}`}>
                <div className="wave wave-3">
                    <div className="wave wave-2">
                        <div className="wave wave-1">{this.props.children}</div>
                    </div>
                </div>
            </div>
        );
    }
}

Pulsing.defaultProps = {
    pulseAfter: []
};

Pulsing.propTypes = {
    pulseAfter: PropTypes.arrayOf(PropTypes.number)
};

export default Pulsing;
